const MainSearch = class extends HTMLElement {
  constructor() {
    super();
    
    console.log('MainSearch initialized:', this);

    // Initialize dynamic search positioning
    this.initializeDynamicPositioning();

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      console.log('Found close button:', el);
      // Add both mouse and touch event support
      const handleClose = (evt) => {
        console.log('Close button clicked/touched');
        evt.preventDefault();
        evt.stopPropagation();
        document.body.classList.remove('show-search');
        this.hideOverlay();
        
        // Clear search input
        const searchInput = this.querySelector('.main-search__input');
        if (searchInput) {
          searchInput.value = '';
          searchInput.blur();
        }
        
        // Remove search input content state
        document.body.classList.remove('search-has-input');
        
        // Hide predictive search results if they exist
        const predictiveResults = document.querySelector('#predictive-search-focus-results');
        if (predictiveResults) {
          predictiveResults.style.visibility = 'hidden';
          predictiveResults.style.opacity = '0';
          predictiveResults.classList.remove('active-search');
        }
      };
      
      // Add multiple event listeners for better mobile support
      el.addEventListener('click', handleClose);
      el.addEventListener('touchend', (evt) => {
        evt.preventDefault();
        handleClose(evt);
      }, { passive: false });
    });

    // Clicking close-btn-drawer (for Jungfeld search)
    this.querySelectorAll('.close-btn-drawer').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
        this.hideOverlay();
      });
    });

    // Clicking mobile close button
    this.querySelectorAll('.close-btn-drawer-mobile').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
        this.hideOverlay();
      });
    });

    // Pressing escape key
    const searchInput = this.querySelector('.main-search__input');
    if (searchInput) {
      searchInput.addEventListener('keyup', (evt) => {
        if (evt.key === 'Escape') {
          document.body.classList.remove('show-search');
          this.hideOverlay();
        }
      });
    }

    // Clicking overlay to close search
    const overlay = document.querySelector('.js-overlay');
    if (overlay) {
      overlay.addEventListener('click', (evt) => {
        if (document.body.classList.contains('show-search')) {
          evt.preventDefault();
          document.body.classList.remove('show-search');
          this.hideOverlay();
        }
      });
    }

    // Search as you type (keep the existing functionality)
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  hideOverlay() {
    const overlay = document.querySelector('.js-overlay');
    if (overlay) {
      overlay.classList.remove('is-visible');
    }
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 500;
    const resultLimit = 8;
    const includeMeta = this.dataset.quickSearchMeta === 'true';
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      const valueToSearch = searchInput.value;

      // Only search if search string longer than 2, and it has changed
      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        // Save previous value
        this.oldSearchValue = valueToSearch;

        // Kill outstanding ajax request
        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }

        // Kill previous search
        clearTimeout(searchTimeoutID);

        // Create URL for full search results
        const form = searchInput.closest('form');
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => { linkURL.searchParams.set(key, value); });

        // Show loading
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        this.classList.add('main-search--loading');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl;

          if (theme.Shopify.features.predictiveSearch) {
            // use the API
            ajaxUrl = new URL(theme.routes.base + theme.routes.predictiveSearch);
            ajaxUrl.searchParams.set('q', valueToSearch);
            ajaxUrl.searchParams.set('section_id', 'predictive-search');
            ajaxUrl.searchParams.set('resources[limit]', resultLimit);
            ajaxUrl.searchParams.set('resources[options][fields]', includeMeta ? 'title,product_type,variants.title,vendor,tag,variants.sku' : 'title,product_type,variants.title,vendor');
          } else {
            // use the theme template fallback
            ajaxUrl = new URL(linkURL);
            ajaxUrl.searchParams.set('section_id', 'main-search');
          }

          fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const template = document.createElement('template');
              template.innerHTML = response;
              let resultsList = null;
              if (theme.Shopify.features.predictiveSearch) {
                resultsList = template.content.querySelector('.product-grid');
              } else {
                resultsList = template.content.querySelector('.section-search-template .product-grid');
              }

              // reset previous contents
              searchAbortController = null;
              this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
              resultsBox.innerHTML = '';

              const resultsProducts = document.createElement('div');
              resultsProducts.className = 'main-search__results__products collection-listing';
              resultsProducts.innerHTML = '<div></div>';
              const resultsPages = document.createElement('div');
              resultsPages.className = 'main-search__results__pages';

              resultsProducts.firstElementChild.className = resultsList.className;

              // Convert standard blocks into quick search result format
              resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)').forEach((block, index) => {
                if (index <= resultLimit) {
                  block.classList.add('main-search-result');
                  block.querySelectorAll('.btn.quickbuy-toggle').forEach((el) => el.remove());
                  block.querySelectorAll('.quickbuy-toggle').forEach((el) => el.classList.remove('quickbuy-toggle'));
                  resultsProducts.firstElementChild.appendChild(block);
                }
              });

              resultsList.querySelectorAll('.product-block.page-block').forEach((block) => {
                const item = document.createElement('a');
                item.className = 'main-search-result main-search-result--page';
                item.href = block.querySelector('a').href;
                item.innerHTML = '<div class="main-search-result__text"></div>';
                item.firstElementChild.innerText = block.querySelector('.page-block__title').innerText;
                resultsPages.appendChild(item);
              });

              this.classList.remove('main-search--loading');

              const areProducts = !!resultsProducts.querySelector('.main-search-result');
              const arePages = !!resultsPages.querySelector('.main-search-result');
              if (areProducts || arePages) {
                // Numerous results
                this.classList.add('main-search--has-results');
                this.classList.toggle('main-search--results-on-multiple-lines', resultsProducts.querySelectorAll('.product-block').length > 4);
                
                // Add "View All" button at the TOP
                const allLink = document.createElement('a');
                allLink.className = 'main-search__results-all-link btn btn--secondary';
                allLink.href = linkURL;
                allLink.innerHTML = theme.strings.generalSearchViewAll;
                resultsBox.appendChild(allLink);
                
                if (areProducts) {
                  resultsBox.appendChild(resultsProducts);
                }
                if (arePages) {
                  const heading = document.createElement('h6');
                  heading.className = 'main-search-result__heading';
                  heading.innerHTML = theme.strings.generalSearchPages;
                  resultsPages.insertAdjacentElement('afterbegin', heading);
                  resultsBox.appendChild(resultsPages);
                }
              } else {
                // No results - show nothing
                this.classList.add('main-search--no-results');
                const emptyMessage = document.createElement('div');
                emptyMessage.className = 'main-search__empty-message';
                emptyMessage.innerHTML = theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            })
            .catch((error) => {
              console.warn(error);
            });
        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        // Abandon current search
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        // Clear results
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading');
        resultsBox.innerHTML = '';
      }
    };

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));
    
    // Handle input event to manage predictive search visibility
    searchInput.addEventListener('input', function() {
      if (this.value.length > 0) {
        // Hide predictive search results when input has content
        document.body.classList.add('search-has-input');
      } else {
        // Show predictive search results when input is empty
        document.body.classList.remove('search-has-input');
      }
    });
  }

  // Initialize dynamic positioning for search results
  initializeDynamicPositioning() {
    // Set initial position
    this.updateSearchResultsPosition();
    
    // Update position on window resize
    window.addEventListener('resize', () => {
      this.updateSearchResultsPosition();
    });
    
    // Update position when search becomes active
    const searchInput = this.querySelector('.main-search__input');
    if (searchInput) {
      searchInput.addEventListener('focus', () => {
        setTimeout(() => this.updateSearchResultsPosition(), 100);
      });
    }
  }

  // Calculate and update the search results position based on header height
  updateSearchResultsPosition() {
    const searchResults = document.querySelector('#predictive-search-focus-results');
    if (!searchResults) return;

    let headerElement;
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      // On mobile, use the main-search element height
      headerElement = document.querySelector('main-search.main-search-old, main-search.main-search');
      if (!headerElement) {
        // Fallback to any main-search element  
        headerElement = document.querySelector('main-search');
      }
    } else {
      // On desktop, use the page-header element
      headerElement = document.querySelector('page-header');
      if (!headerElement) {
        // Fallback to any element with page-header class
        headerElement = document.querySelector('.page-header');
      }
    }

    if (headerElement) {
      const headerHeight = headerElement.offsetHeight;
      const headerTop = headerElement.offsetTop || 0;
      const totalOffset = headerTop + headerHeight;
      const finalPosition = totalOffset;
      
      searchResults.style.top = `${finalPosition}px`;
      
      console.log(`Search results positioned at: ${finalPosition}px (${isMobile ? 'mobile' : 'desktop'} mode)`);
    } else {
      // Fallback to original values if elements not found
      const fallbackTop = isMobile ? '125px' : '125px';
      searchResults.style.top = fallbackTop;
      console.warn(`Header element not found, using fallback position: ${fallbackTop}`);
    }
  }
};

window.customElements.define('main-search', MainSearch);
